const englishTranslations = {
  notifications: {
    basdaiNotificationMsg:
      "Your doctor has requested a BASDAI pain score assessment before your next visit. You'll get a reminder the day before.",
    basfiNotificationMsg:
      "Your doctor has requested a BASFI pain score assessment before your next visit. You'll get a reminder the day before.",
    rapid3NotificationMsg:
      "Your doctor has requested a RAPID3 pain score assessment before your next visit. You'll get a reminder the day before.",
    common: {
      dismiss: "Dismiss",
      close: "Close",
      view: "View",
      ok: "Ok",
    },
  },
};

const marathiTranslations = {
  notifications: {
    basdaiNotificationMsg:
      "डॉक्टरांनी तुम्हाला तुमच्या पुढील अपॉइंटमेंटपूर्वी IC4 अॅपवर BASDAI पेन स्कोअर चाचणी पूर्ण करण्यास सांगितले आहे. तुमच्या पुढील अपॉइंटमेंटच्या आदल्या दिवशी सुद्धा तुम्हाला याची आठवण करून दिली जाईल.",
    basfiNotificationMsg:
      "डॉक्टरांनी तुम्हाला तुमच्या पुढील अपॉइंटमेंटपूर्वी IC4 अॅपवर BASFI पेन स्कोअर चाचणी पूर्ण करण्यास सांगितले आहे. तुमच्या पुढील अपॉइंटमेंटच्या आदल्या दिवशी सुद्धा तुम्हाला याची आठवण करून दिली जाईल.",
    rapid3NotificationMsg:
      "डॉक्टरांनी तुम्हाला तुमच्या पुढील अपॉइंटमेंटपूर्वी IC4 अॅपवर RAPID-3 पेन स्कोअर चाचणी पूर्ण करण्यास सांगितले आहे. तुमच्या पुढील अपॉइंटमेंटच्या आदल्या दिवशी सुद्धा तुम्हाला याची आठवण करून दिली जाईल.",
    common: {
      dismiss: "Dismiss",
      close: "Close",
      view: "View",
      ok: "Ok",
    },
  },
};

const hindiTranslations = {
  notifications: {
    basdaiNotificationMsg:
      "डॉक्टर ने आपको अपनी अगली अपॉइंटमेंट से पहले IC4 ऐप पर BASDAI पेन स्कोर टेस्ट पूरा करने के लिए कहा है। आपकी अगली अपॉइंटमेंट से एक दिन पहले भी आपको इसकी याद दिलाई जाएगी।",
    basfiNotificationMsg:
      "डॉक्टर ने आपको अपनी अगली अपॉइंटमेंट से पहले IC4 ऐप पर BASFI पेन स्कोर टेस्ट पूरा करने के लिए कहा है। आपकी अगली अपॉइंटमेंट से एक दिन पहले भी आपको इसकी याद दिलाई जाएगी।",
    rapid3NotificationMsg:
      "डॉक्टर ने आपको अपनी अगली अपॉइंटमेंट से पहले IC4 ऐप पर RAPID-3 पेन स्कोर टेस्ट पूरा करने के लिए कहा है। आपकी अगली अपॉइंटमेंट से एक दिन पहले भी आपको इसकी याद दिलाई जाएगी।",
    common: {
      dismiss: "Dismiss",
      close: "Close",
      view: "View",
      ok: "Ok",
    },
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
